<template>
  <div class="credit-card-brand">
    <Visa v-if="isVisa" :width="iconWidth" :height="iconHeight" />
    <Mastercard v-if="isMaster" :width="iconWidth" :height="iconHeight" />
    <Jcb v-if="isJcb" :width="iconWidth" :height="iconHeight" />
    <AmericanExpress v-if="isAmex" :width="iconWidth" :height="iconHeight" />
    <DinersClub v-if="isDiners" :width="iconWidth" :height="iconHeight" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Visa from '../../atoms/svg_icons/credit_card_brands/Visa.vue'
import Mastercard from '../../atoms/svg_icons/credit_card_brands/Mastercard.vue'
import Jcb from '../../atoms/svg_icons/credit_card_brands/Jcb.vue'
import AmericanExpress from '../../atoms/svg_icons/credit_card_brands/AmericanExpress.vue'
import DinersClub from '../../atoms/svg_icons/credit_card_brands/DinersClub.vue'

const BrandType = {
  JCB: 'JCB',
  VISA: 'Visa',
  MASTER: 'Mastercard',
  AMEX: 'American Express',
  DINERS: 'Diners Club'
}

const props = defineProps({
  brandType: {
    type: String,
    required: false,
    default: ''
  },
  iconWidth: {
    type: Number,
    required: false,
    default: 48
  },
  iconHeight: {
    type: Number,
    required: false,
    default: 32
  }
})

const isJcb = computed(() => props.brandType === BrandType.JCB)
const isVisa = computed(() => props.brandType === BrandType.VISA)
const isMaster = computed(() => props.brandType === BrandType.MASTER)
const isAmex = computed(() => props.brandType === BrandType.AMEX)
const isDiners = computed(() => props.brandType === BrandType.DINERS)
</script>
